export const stripWhiteSpace = item => {
  return item.replace(/\s+/g, '');
}